<template>
    <div>
        <!-- dummy -->
        <!-- <v-snackbar v-model="show" color="green" text right="right" timeout="50000" top="top">
            <span class="font-weight-medium">Loras alert!</span>
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" color="green" @click="show=false">Close</v-btn>
            </template>
        </v-snackbar> -->

        <v-snackbar
            v-for="(n, i) in alerts.length"
            :key="alerts[i].id"
            v-model="alerts[i].show"
            :color="alerts[i].color" 
            :style="{ transform: `translateY(${(i) * 60}px)` }"
            style="transition-duration: .3s; z-index: 4;"
            text
            right
            top
            timeout="-1"
            min-width="240"
            max-width="380"
        >
            <span class="font-weight-medium">{{ alerts[i].msg }}</span>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    :color="alerts[i].color"
                    class="px-1"
                    @click="pop(alerts[i].id)"
                    >{{ $langs.Gen.close[$langs.lang] }}</v-btn
                >
            </template>
        </v-snackbar>

        <!-- Alert Debug -->
        <!-- <div style="position: fixed; top: 120px; left: 40px; z-index: 99">
            <input
                type="number"
                style="background: white"
                placeholder="remove id then enter"
                v-on:keyup.enter="pop($event.target.value, $event);"
            />
            <pre class="text-caption">{{ alerts }}</pre>
        </div> -->
    </div>
</template>

<script>
import { mapState } from "vuex";

//
// Alert message
//      Using 'mapState' and 'watch' variable 'alertInfo' in vuex (vue store),
//      looking for a change then add new change to 'alerts' queue (first in first out)
//

export default {
    data() {
        return {
            show: true,
            cnt: 0,
            alerts: [],
        };
    },
    computed: mapState(["alertInfo"]),
    watch: {
        alertInfo(n, o) {
            const id = this.cnt++;

            // add new alert
            this.alerts.push({
                color: n.color,
                msg: n.msg,
                show: false,
                id: id,
            });
            let len = this.alerts.length;

            // alert fade in
            setTimeout(
                () => (this.alerts[len - 1].show = true),
                20
            );

            // alert fade out (in ...s)
            const fadeOutIn = n.duration || 4900;
            setTimeout(() => this.pop(id), fadeOutIn);
        },
    },
    methods: {
        pop(id, event=null) {
            if (event) setTimeout(() =>  event.target.value = '', 200);
            if (!this.alerts.length) return;

            for (let i in this.alerts) {
                if (this.alerts[i].id == id) {
                    // fade alert
                    this.alerts[i].show = false;

                    // wait for alert to fully disappert, then remove it
                    setTimeout(() => {
                        if (!this.alerts[i]) return this.pop(id);
                        this.alerts.splice(i, 1);
                    }, 100);
                    break;
                }
            }
        },
    },
};
</script>

<style>
</style>